import AuthContextProvider from "./src/contexts/AuthContextProvider"
import "react-toastify/dist/ReactToastify.css"
export const wrapRootElement = ({ element }) => {
  return <AuthContextProvider>{element}</AuthContextProvider>
}
